export const getRequestKey = (
  parameters: Record<string, unknown> | undefined,
  entityName: string,
): string => (parameters ? JSON.stringify(parameters) : entityName);
